import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { UnionOfficeService } from '../union-office.service'

@Component({
  selector: 'app-union-office-table',
  templateUrl: './union-office-table.component.html',
  styleUrls: ['./union-office-table.component.scss']
})
export class UnionOfficeTableComponent implements OnInit {

  
  dataSource: any;
  displayedColumns: string[] = ['id', 'name', 'union','street','address', 'taluk','district', 'mobile'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private global: GlobalService, private http : HttpService, public unionOfficeService: UnionOfficeService) { 
    this.global.set_master_page_title = 'Union Office';
    this.getUnionOffice();
    this.unionOfficeService.downloadUnionOffice.subscribe((union_office) => {
      console.log(union_office);
      if (union_office) {
        this.getUnionOffice();
      }
    });
  }

  getUnionOffice() {
    this.http.getOffice().subscribe((data: UnionOffice[]) => {
      console.log(data);
      this.dataSource = new MatTableDataSource<UnionOffice>(data);
      this.dataSource.sort = this.sort;
    }, (error) => {
      console.log(error);
    });
  }

  registerUnionOffice() {
    this.showUnionOfficeRegister();
    this.unionOfficeService.unionOfficeUpdate.emit(null);
    this.unionOfficeService.set_union_office_data = null;
  }


  hideUnionOfficeRegister() {
    this.unionOfficeService.is_display_union_office_register_component = false;
  }

  showUnionOfficeRegister() {
    this.unionOfficeService.is_display_union_office_register_component = true;
  }

  editUnionOffice(element) {
    this.showUnionOfficeRegister();
    this.unionOfficeService.unionOfficeUpdate.emit(element);
    this.unionOfficeService.set_union_office_data = element;
  }


  ngOnInit() {
  }

}
export interface UnionOffice {
  id: number;
  name: string;
}
